import { messageUserNoticeList } from '@/api/message'

const state = {
  notices: []
}

const mutations = {
  SET_NOTICES: (state, value) => {
    state.notices = value
  }
}

const actions = {
  async getNotices({ commit }) {
    const resp = await messageUserNoticeList()
    commit('SET_NOTICES', resp.list)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

